import { render, staticRenderFns } from "./FormNewPartner.vue?vue&type=template&id=533faf07&"
import script from "./FormNewPartner.vue?vue&type=script&lang=js&"
export * from "./FormNewPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports